import { ValueOfKey } from '../../../../utils-types';

export const PRE_REGISTERED_COLUMN = {
  NAME: 'NAME',
  COACH: 'COACH',
  DATE_OF_UPDATE: 'DATE_OF_UPDATE',
} as const;

export type PreRegisteredColumn = ValueOfKey<typeof PRE_REGISTERED_COLUMN>;
export type ShowColumnsConfig = Record<PreRegisteredColumn, boolean>;

export const COLUMN_WIDTHS: Record<PreRegisteredColumn, string> = {
  NAME: '1fr',
  COACH: '1fr',
  DATE_OF_UPDATE: 'auto',
};
